import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 70,
  },
  path: {
    fill: '#7df3e1',
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <img
      className={classes.svg}
      src="/bandits-full.png"
      alt="Logo"
    />
  );
};

export default LogoFull;
